// extracted by mini-css-extract-plugin
export default {"card":"team_card__wLoZx","card_tag":"team_card_tag__ylxgK","cards_container":"team_cards_container__U+1Pz","value":"team_value__KEaLL"};